import { MagentoAddress } from '~/types/MagentoAddress'

export function isAddressValid (address: MagentoAddress): boolean {
  return [
    address?.street,
    address?.city,
    address?.postcode
  ].every(Boolean)
}
